import { render, staticRenderFns } from "./users-echart.vue?vue&type=template&id=88ad503e&scoped=true&"
import script from "./users-echart.vue?vue&type=script&lang=js&"
export * from "./users-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ad503e",
  null
  
)

export default component.exports